// extracted by mini-css-extract-plugin
module.exports = {"index":"index_index_3O8nr","title":"index_title_3nj_t"};